module.exports = __webpack_public_path__ + "static/media/IMG_1455.4ebd3561.PNG";